import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const ResultModal = ({ open, onClose, successfulData, failedData }) => {
  const hasSuccessfulData = successfulData && successfulData.length > 0;
  const hasFailedData =
    (failedData && failedData.length > 0) ||
    (failedData &&
      !Array.isArray(failedData) &&
      typeof failedData === "object");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="h6">Processing Results</Typography>
          {hasSuccessfulData && (
            <Chip
              icon={<CheckCircleIcon />}
              label={`${successfulData.length} Successful`}
              color="success"
              size="small"
            />
          )}
          {hasFailedData && Array.isArray(failedData) && (
            <Chip
              icon={<ErrorIcon />}
              label={`${failedData.length} Failed`}
              color="error"
              size="small"
            />
          )}
        </Box>
      </DialogTitle>

      <DialogContent>
        {hasSuccessfulData && (
          <Box mb={3}>
            <Typography variant="h6" color="success.main" gutterBottom>
              Successful Records ({successfulData.length})
            </Typography>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Row</TableCell>
                    <TableCell>Merchant Name</TableCell>
                    <TableCell>Merchant ID</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {successfulData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.row || index + 1}</TableCell>
                      <TableCell>
                        {item?.item?.acquirer?.merchantName ||
                          item.name ||
                          "N/A"}
                      </TableCell>
                      <TableCell>
                        {item?.item?.acquirer?.merchantID ||
                          item.merchantId ||
                          "N/A"}
                      </TableCell>
                      <TableCell>
                        <Chip label="Success" color="success" size="small" />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        {hasFailedData && (
          <Box>
            <Typography variant="h6" color="error.main" gutterBottom>
              Failed Records{" "}
              {Array.isArray(failedData) && `(${failedData.length})`}
            </Typography>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Row</TableCell>
                    <TableCell>Merchant Name</TableCell>
                    <TableCell>Merchant ID</TableCell>
                    <TableCell>Error</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {failedData &&
                    Array.isArray(failedData) &&
                    failedData.map((item, index) => (
                      <TableRow key={`${item.error?.message}-${index}`}>
                        <TableCell>{item.row || index + 1}</TableCell>
                        <TableCell>
                          {item?.item?.acquirer?.merchantName ||
                            item?.item?.name ||
                            "N/A"}
                        </TableCell>
                        <TableCell>
                          {item?.item?.acquirer?.merchantID ||
                            item?.item?.acquirer?.merchantId ||
                            "N/A"}
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="error">
                            {item.error?.message ||
                              item.message ||
                              "Unknown error"}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  {failedData && !Array.isArray(failedData) && (
                    <TableRow>
                      <TableCell>
                        {failedData?.error?.lineNumber || 1}
                      </TableCell>
                      <TableCell>
                        {failedData?.error?.merchantName ||
                          failedData?.error?.["Merchant Name"] ||
                          failedData?.error?.name ||
                          "N/A"}
                      </TableCell>
                      <TableCell>
                        {failedData?.error?.merchantID ||
                          failedData?.error?.MerchantID ||
                          failedData?.error?.merchantId ||
                          "N/A"}
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" color="error">
                          {failedData?.message || "Unknown error"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        {!hasSuccessfulData && !hasFailedData && (
          <Typography variant="body1" color="text.secondary">
            No data to display
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResultModal;
